module.exports = __webpack_public_path__ + "img/thumbnail_Alpaca_f_normal.8687e25c.png";